import $ from 'jquery';

$('.testimonials-slider').slick({
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  prevArrow: $('.prev-arrow'),
  nextArrow: $('.next-arrow'),
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        dots: true,
        arrows: false,
      },
    },
  ],
});
